<div class="main-page d-flex row">
  <div class="col-2 px-0">
    <app-user-left-side-bar></app-user-left-side-bar>
  </div>
  <div class="content-page col-10 px-0">
    <div class="navbar-custom">
      <app-user-header></app-user-header>
    </div>
    <div class="content position-relative">
      <div class="container-fluid mt-2">
        <router-outlet></router-outlet>
      </div>
      <div class="loader d-flex flex-column position-absolute" *ngIf="loading">
        <div class="spinner-border" role="status">
        </div>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <app-user-footer></app-user-footer>
  </div>
</div>